import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted, per the handoff's assets note. Weights are pulled individually so the bundle
// carries only what the designs actually use.
import '@fontsource/plus-jakarta-sans/400.css'
import '@fontsource/plus-jakarta-sans/600.css'
import '@fontsource/plus-jakarta-sans/700.css'
import '@fontsource/ibm-plex-sans/400.css'
// 500 is used by body-face kickers, counts and table labels (live.css). Without it the browser
// matched the nearest loaded weight, 400, and the emphasis those rules ask for silently vanished.
import '@fontsource/ibm-plex-sans/500.css'
import '@fontsource/ibm-plex-sans/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

import './tokens/tokens.css'
import './tokens/base.css'
import { App } from './App'

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
